import type {Dayjs} from 'dayjs';

export enum UAV_POINT_CLOUD_STATUS {
  DATA_PENDING = 'DATA_PENDING',
  DATA_UPLOADED = 'DATA_UPLOADED',
}

export type UavPointCloud = {
  uuid: string;
  forestMassUuid: string;
  status: UAV_POINT_CLOUD_STATUS;
  flightDate: Dayjs;
  lidarTechnologyUuid: string;
  height: number;
  speed: number;
  overlapPercentage: number;
  comments?: string;
  createdAt: Dayjs;
};

export type UavPointCloudCreate = Omit<UavPointCloud, 'uuid'>;

export type UavPointCloudUrls = {
  uploadUrl: string;
  downloadUrl: string;
};
